/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { find, merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Card, Box } from '@material-ui/core';
//
import { BaseOptionChart } from '../../charts';
import VPUDashboardService from './VPUDashboardService';
import TokenDecoder from '../../../helpers/TokenDecoder';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import getDate from 'date-fns/getDate';
import { trackPromise } from 'react-promise-tracker';

export default function DemandAndSupplyYesterdayVCC() {

    const [data, setData] = useState([]);
    const [vccNames, setVccNames] = useState([]);

    let productNameArray = [];

    async function GetDemandData() {
        const demand = await VPUDashboardService.GetDemandSKUwiseVPUDashboard();
        const supply = await VPUDashboardService.GetSupplyVCCwiseVPUDashboard();
        const demandQuantity = await VPUDashboardService.GetDemandVCCwiseVPUDashboard();

        let SupplyList = [...supply]
        let DemandList = [...demand]

        DemandList.forEach(x => {
            productNameArray.push(x.productName)
        })

        let newDataArray = [...supply];

        let vccArray = [];
        newDataArray.forEach(x => {
            x.productList.forEach(y => {
                vccArray.push(y.factoryName)
            });
        });

        const uniqueVccArray = [...new Set(vccArray)];

        uniqueVccArray.sort((a, b) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });

        let demandQuantityArray = [];
        demandQuantity.sort((a, b) => {
            if (a.factoryName < b.factoryName) return -1;
            if (a.factoryName > b.factoryName) return 1;
            return 0;
        });

        demandQuantity.forEach(x => {
            demandQuantityArray.push(x.quantity)
        })

        newDataArray.forEach(x => {

            let factoryArray = [];

            x.productList.forEach(y => {
                factoryArray.push(y.factoryName);
            });

            let newValues = uniqueVccArray.filter(value => !factoryArray.includes(value));
            if (newValues.length > 0) {
                newValues.forEach(z => {
                    let item = {
                        factoryName: z,
                        orderDate: '2023-01-30T00:00:00',
                        productName: x.productName,
                        quantity: 0,
                        acceptedQuantity: 0
                    };
                    x.productList.push(item);
                })
            }
            x.productList.sort((a, b) => {
                if (a.factoryName < b.factoryName) return -1;
                if (a.factoryName > b.factoryName) return 1;
                return 0;
            });
        })

        let arrays = [];

        // newDataArray.forEach(x => {
        //     let arrays2 = [];
        //     x.productList.forEach(y => {
        //         arrays2.push(
        //             y.acceptedQuantity
        //         );
        //     });
        //     arrays.push({
        //         name: x.productName,
        //         data: arrays2
        //     })
        // });
        arrays.unshift({
            name: "Demand",
            data: demandQuantityArray
        });

        setData(arrays);
        setVccNames(uniqueVccArray)
    }

    useEffect(() => {
        trackPromise(GetDemandData());
    }, [])

    let randomColorGenerator = function () {
        return '#' + (Math.random().toString(16) + '0000000').slice(2, 8);
    };

    let colorArray = []
    data.forEach(element => {
        colorArray.push(randomColorGenerator())
    });

    const state = {
        series: data,
        options: {
            colors: ['#45ba6a'],
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                toolbar: {
                    show: true,
                    tools: {
                        download: false
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    dataLabels: {
                        total: {
                            enabled: true,
                            offsetX: 0,
                            style: {
                                fontSize: '13px',
                                fontWeight: 900
                            }
                        }
                    },
                    columnWidth: '45%'
                },
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },
            title: {
                text: ''
            },
            xaxis: {
                categories: [...vccNames],
                labels: {
                    formatter: function (val) {
                        return val
                    }
                }
            },
            yaxis: {
                title: {
                    text: undefined
                },
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return val
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                show: false
            }
        },
    };


    return (
        <>
            <LoadingComponent />
            <div id="chart">
                <Card style={{ justifycontent: 'center', padding: '1.5rem' }} >
                    <h3>Demand QTY (VCC)  </h3>
                    {/* <h5>(From {new Date().toISOString().slice(0, 10)} To {(new Date(new Date().setDate(new Date().getDate() + 7)).toISOString().split('T')[0])}) </h5><br /> */}
                    <ReactApexChart options={state.options} series={state.series} type="bar" height={530} />
                </Card>
            </div>
        </>
    );
}





